import { render, staticRenderFns } from "./sleep.vue?vue&type=template&id=d675238c&scoped=true"
import script from "./sleep.vue?vue&type=script&lang=js"
export * from "./sleep.vue?vue&type=script&lang=js"
import style0 from "./sleep.vue?vue&type=style&index=0&id=d675238c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d675238c",
  null
  
)

export default component.exports